import { makeStyles } from '@material-ui/core/styles'

import palette from 'theme/palette'

export const useValuesStepStyles = makeStyles(theme => ({
  setupSection: {
    width: '100%',
    maxWidth: 1200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  substepContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'opacity 160ms ease'
  },
  completedSubstep: {
    pointerEvents: 'none',
    opacity: 0.3
  },
  choiceGrid: {
    width: '100%',
    maxWidth: 820,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  choiceCard: {
    minHeight: 154,
    padding: theme.spacing(2.5),
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    border: '1px solid #dfe5e8',
    borderRadius: 12,
    background: '#fff',
    color: '#263238',
    fontFamily: 'Roboto, sans-serif',
    textAlign: 'left',
    cursor: 'pointer',
    transition: 'border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease',
    '&:hover': {
      borderColor: palette.primary.main,
      boxShadow: '0 8px 24px rgba(38, 50, 56, 0.08)',
      transform: 'translateY(-1px)'
    },
    '&:focus-visible': {
      outline: `2px solid ${palette.primary.main}`,
      outlineOffset: 2
    },
    '&:disabled': {
      cursor: 'default'
    }
  },
  selectedChoice: {
    borderColor: palette.primary.main,
    background: '#f4f5fd',
    boxShadow: `0 0 0 1px ${palette.primary.main}`
  },
  choiceIcon: {
    width: 42,
    height: 42,
    flex: '0 0 42px',
    display: 'grid',
    placeItems: 'center',
    borderRadius: 10,
    background: '#eef0fc',
    color: palette.primary.main
  },
  choiceContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    '& strong': {
      fontSize: 15,
      lineHeight: 1.35
    },
    '& span': {
      color: '#65747b',
      fontSize: 13,
      lineHeight: 1.5
    }
  },
  recommended: {
    width: 'fit-content',
    marginTop: theme.spacing(0.5),
    padding: '3px 7px',
    borderRadius: 20,
    background: '#e4e7f8',
    color: `${palette.primary.main} !important`,
    fontSize: '10px !important',
    fontWeight: 700,
    letterSpacing: 0.4,
    textTransform: 'uppercase'
  },
  manualSection: {
    width: '100%',
    marginTop: theme.spacing(7),
    paddingTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    borderTop: '1px solid #edf0f2'
  },
  manualContent: {
    width: '100%',
    transition: 'opacity 160ms ease'
  },
  manualHeader: {
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    '& h2': {
      margin: 0,
      color: '#263238',
      fontSize: 18
    }
  },
  advanceAction: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2)
  },
  modeAdvanceAction: {
    maxWidth: 820
  },
  primaryAdvanceAction: {
    marginTop: theme.spacing(4)
  },
  advanceButton: {
    padding: '9px 12px',
    display: 'flex',
    alignItems: 'center',
    border: 0,
    borderRadius: 5,
    background: palette.primary.main,
    color: '#fff',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    cursor: 'pointer',
    '& svg': {
      marginLeft: 10,
      fontSize: 10
    },
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.4
    }
  },
  advanceTooltipTarget: {
    display: 'inline-flex'
  },
  editButton: {
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    borderRadius: 5,
    background: '#e8e5eb',
    color: palette.primary.main,
    fontFamily: 'Roboto, sans-serif',
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    cursor: 'pointer',
    '& svg': {
      marginLeft: 5,
      fontSize: 18
    }
  },
  resetList: {
    margin: `0 0 ${theme.spacing(2.5)}px`,
    padding: 0,
    listStyle: 'none',
    '& li': {
      color: '#263238',
      fontFamily: 'Roboto, sans-serif',
      fontSize: 13,
      fontWeight: 700,
      textAlign: 'center'
    }
  },
  remunerationSection: {
    width: '100%',
    marginTop: theme.spacing(6),
    paddingTop: theme.spacing(5),
    borderTop: '1px solid #e6eaed'
  }
}))
